import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Dimmer, Loader, Pagination, Table } from 'semantic-ui-react';
import { getEmployeeSlotsLogs } from 'state/business/actions';

const EmployeeLogs = props => {
  const {
    gettingEmployeeSlotsLogs,
    allBusiness,
    employeeSlotsLogs,
    employeeLogsPage,
    dispatch,
  } = props;

  useEffect(() => {
    const businessId = allBusiness.data[allBusiness.activeIndex].id;
    const payload = {
      businessId,
      size: 10,
      employeeLogsPage: 1,
    };
    dispatch(getEmployeeSlotsLogs(payload));
  }, [allBusiness.activeIndex, allBusiness.data, dispatch]);

  const size = 10;
  let totalPages = 1;
  if (employeeSlotsLogs.paging)
    totalPages = Math.ceil(employeeSlotsLogs.paging.total / size);

  const handleOnPageChange = (_, val) => {
    const businessId = allBusiness.data[allBusiness.activeIndex].id;
    const { activePage } = val;
    const payload = {
      businessId,
      size: 10,
      employeeLogsPage: activePage,
    };
    dispatch(getEmployeeSlotsLogs(payload));
  };

  return (
    <>
      <Dimmer active={gettingEmployeeSlotsLogs}>
        <Loader size="massive">Loading</Loader>
      </Dimmer>
      <div style={{ 'overflow-x': 'scroll' }}>
        <Table>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Time (JKT)</Table.HeaderCell>
              <Table.HeaderCell>Logs</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {employeeSlotsLogs.data ? (
              employeeSlotsLogs.data.internal_tools_activities.map(logs => {
                return (
                  <Table.Row>
                    <Table.Cell>{logs.time.replace(/T|Z/g, ' ')}</Table.Cell>
                    <Table.Cell>{logs.log}</Table.Cell>
                  </Table.Row>
                );
              })
            ) : (
              <></>
            )}
          </Table.Body>
          {employeeSlotsLogs.paging ? (
            <Table.Footer>
              <Table.Row>
                <Table.HeaderCell colSpan="7">
                  <Pagination
                    activePage={employeeLogsPage}
                    totalPages={totalPages}
                    onPageChange={handleOnPageChange}
                    size="mini"
                  />
                </Table.HeaderCell>
              </Table.Row>
            </Table.Footer>
          ) : (
            <></>
          )}
        </Table>
      </div>
    </>
  );
};

const mapStateToProps = ({ business }) => ({
  employeeSlotsLogs: business.employeeSlotsLogs,
  employeeLogsPage: business.employeeLogsPage,
  allBusiness: business.allBusiness,
  gettingEmployeeSlotsLogs: business.gettingEmployeeSlotsLogs,
});

EmployeeLogs.propTypes = {
  dispatch: PropTypes.func.isRequired,
  employeeSlotsLogs: PropTypes.object.isRequired,
  employeeLogsPage: PropTypes.number.isRequired,
  allBusiness: PropTypes.object.isRequired,
  gettingEmployeeSlotsLogs: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps)(EmployeeLogs);
